<!-- Copyright (c) 2023 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="cont-delivery-type-main">
    <div>
      <Menus
        :menu="menu"
        icon="https://dsmlib.logistics.systems/Icons/ContDeliveryType.png"
        :menuWidth="230"
        @menuClicked="menuClicked"
      />
    </div>
    <div class="cont-delivery-type-table">
      <TableBox
        :tableData="ContDeliveryTypeList"
        :selectedRow.sync="selectedArea"
        title="Cont Delivery Type"
        :dataType="columnTypeMain"
      />
    </div>
    <PopupEntry
      :show.sync="popupEntryShow"
      v-if="popupEntryShow"
      :title="popupEntryTitle"
      :updatedBy="updatedBy"
      :createdBy="createdBy"
      @save="saveClicked"
      :requiredError="entryRequired"
      :successMessages="entrySuccess"
      :messages="entryMessages"
      :errorMessages="entryError"
      @requiredClicked="entryRequiredClicked"
      :viewMode="viewMode"
      :cancelButton="viewMode ? 'Close' : 'Cancel'"
    >
      <div class="General Details" style="display: flex; height: 100%">
        <!-- General Details -->
        <div class="gen-details-right" placeholder="Container Delivery">
          <!-- ContDeliveryType -->
          <Input
            :isDisabled="viewModePK"
            :isRequired="true"
            placeholder="Cont Delivery Type (max. 5 characters)"
            :inputValue.sync="contDeliveryType"
            :errorMessage.sync="contDeliveryTypeError"
            ref="category_contDeliveryType"
            validator="alphanumeric,5,uppercase"
          />
          <!-- ContTypeDescription -->
          <Input
            :isDisabled="viewMode"
            placeholder="Cont Delivery Type Description (max. 50 characters)"
            :inputValue.sync="description"
            :errorMessage.sync="descriptionError"
            ref="category_description"
            validator="text,50"
          />
          <!-- WebView -->
          <Dropdown
            :isDisabled="viewMode"
            placeholder="WebView"
            :selectedObject.sync="webview"
            :search.sync="webViewSearch"
            :items="optionsForWebview"
            itemKey="label"
            :errorMessage.sync="webviewError"
            style="padding-bottom: 30px"
            ref="category_webview"
          />
        </div>
      </div>
    </PopupEntry>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},
  data: function () {
    return {
      menu: [
        {
          title: 'New Cont Delivery Type',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png',
          key: 'MnuNew',
          visible: true,
          enabled: true,
        },
        {
          title: 'Edit Cont Delivery Type',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png',
          key: 'MnuEdit',
          visible: true,
          enabled: true,
        },
        {
          title: 'Delete Cont Delivery Type',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png',
          key: 'MnuDelete',
          visible: false,
          enabled: true,
        },
        {
          title: 'View Cont Delivery Type',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png',
          key: 'MnuQuery',
          visible: true,
          enabled: true,
        },
      ],

      ContDeliveryTypeList: [],
      viewMode: false,
      viewModePK: false,
      popupEntryShow: false,
      menuType: '',
      contDeliveryType: '',
      contDeliveryTypeError: '',
      description: '',
      descriptionError: '',
      webview: null,
      webviewError: '',
      webViewSearch: '',

      entryRequired: [],
      entrySuccess: [],
      entryMessages: [],
      entryError: [],
      selectedArea: [],
      selectedOriginalArea: null,

      optionsForWebview: [
        { label: 'Yes', API_Value: '1' },
        { label: 'No', API_Value: '0' },
      ],
      columnTypeMain: {
        '#': 'number',
        'Cont Delivery Desc': 'number',
      },
    };
  },
  props: {},
  methods: {
    entryRequiredClicked: function (item) {
      this.$nextTick(() => {
        this.$refs[item].setFocus();
      });
    },
    getContDeliveryTypeList: async function () {
      this.ContDeliveryTypeList = [];
      this.$fullscreenLoading('Getting Cont Delivery Type List');
      this.ContDeliveryTypeList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'contdeliverytype' });
      this.$fullscreenLoading();
    },

    menuClicked: async function (e) {
      this.clearEntryMessages();
      this.clearAllFields();
      switch (e.title) {
        case 'New Cont Delivery Type':
          this.clearAllFields();
          this.viewMode = false;
          this.viewModePK = false;
          this.popupEntryShow = true;
          this.descriptionInputIsDisabled = true;
          this.popupEntryTitle = 'New Cont Delivery Type';
          this.updatedBy = '';
          this.createdBy = '';
          this.menuType = 'New';
          break;
        case 'Edit Cont Delivery Type':
          if (this.selectedArea.length == 0) {
            this.$showAlert('error', 'No Cont Delivery Type is selected', 'Please select a Cont Delivery Type to edit');
          } else {
            this.viewMode = false;
            this.viewModePK = true;
            this.popupEntryShow = true;
            this.descriptionInputIsDisabled = false;
            this.popupEntryTitle = 'Edit Cont Delivery Type';
            this.selectedOriginalArea = JSON.parse(JSON.stringify(this.selectedArea[0]));
            await this.populateViewDetails(this.selectedArea[0]['Delivery Type']);
          }
          break;
        case 'Delete Cont Delivery Type':
          if (this.selectedArea.length == 0) {
            this.$showAlert(
              'error',
              'No Cont Delivery Type is selected',
              'Please select a Cont Delivery Type to delete',
            );
          } else {
            const deleting = await this.$showAlert(
              'warning',
              'Delete Cont Delivery Type',
              `Are you sure you want to delete Cont Delivery Type for ${this.selectedArea[0]['Delivery Type']}?`,
              [
                { text: 'Delete', textColor: 'white', color: 'red' },
                { text: 'Cancel', textColor: 'black', color: 'lightgray' },
              ],
            );
            if (deleting == 'Delete') {
              const result = await this.$apiCallV2('/ContDeliveryType/SaveContDeliveryType', {
                action: 'D',
                deliverytype: this.selectedArea[0]['Delivery Type'],
              });
              if (result[0]['Results'] == 0) {
                // Delete successful
                this.$showAlert(
                  'success',
                  'Cont Delivery Type Deleted',
                  `Successfully deleted Cont Delivery Type for ${this.selectedArea[0]['Delivery Type']}`,
                );
                this.$nextTick(async () => await this.getContDeliveryTypeList());
              } else {
                // Delete error
                this.$showAlert(
                  'error',
                  'Cont Delivery Type NOT Deleted',
                  `There was an error deleting Cont Delivery Type for ${this.selectedArea[0]['Delivery Type']}`,
                );
              }
            }
          }
          this.selectedArea = [];
          break;
        case 'View Cont Delivery Type':
          if (this.selectedArea.length == 0) {
            this.$showAlert('error', 'No Cont Delivery Type is selected', 'Please select a Cont Delivery Type to view');
          } else {
            this.viewMode = true;
            this.popupEntryShow = true;
            this.viewModePK = true;
            this.popupEntryTitle = 'View Cont Delivery Type Details';
            await this.populateViewDetails(this.selectedArea[0]['Delivery Type']);
          }
          break;
      }
    },
    clearAllFields: function () {
      this.contDeliveryType = '';
      this.contDeliveryTypeError = '';
      this.description = '';
      this.descriptionError = '';
      this.webview = null;
      this.webViewSearch = '';
      this.menuType = '';
      this.createdBy = '';
      this.updatedBy = '';
    },

    checkFields: function () {
      this.clearEntryMessages();
      if (this.contDeliveryType.length > 5) {
        this.contDeliveryTypeError = 'Cont Delivery Type cannot exceed 5 characters!';
        this.entryRequired.push({
          key: 'category_contDeliveryType',
          value: 'Cont Delivery Type cannot exceed 5 characters!',
        });
      }
      if (this.contDeliveryType == '') {
        this.contDeliveryTypeError = 'Cont Delivery Type is required!';
        this.entryRequired.push({ key: 'category_contDeliveryType', value: 'Cont Delivery Type is required!' });
      }
      if (this.description.length > 50) {
        this.descriptionError = "Cont Delivery Type's Description cannot exceed 50 characters!";
        this.entryRequired.push({
          key: 'category_description',
          value: "Cont Delivery Type's Description cannot exceed 50 characters!",
        });
      }
      if (!this.webview && this.webViewSearch) {
        this.webviewError = 'Webview must be 0, 1 or empty!';
        this.entryRequired.push({ key: 'category_webview', value: 'Webview must be 0, 1 or empty!' });
      }
      return this.entryRequired.length > 0;
    },
    clearEntryMessages: function () {
      this.entryRequired = [];
      this.entrySuccess = [];
      this.entryMessages = [];
      this.entryError = [];
    },
    populateTextTrim: function (text) {
      // To populate text with trim
      return text ? text.trim() : '';
    },
    saveClicked: async function () {
      const isNotValid = this.checkFields();
      if (!isNotValid) {
        const action = this.popupEntryTitle[0];
        if (action == 'E') {
          if (this.selectedOriginalArea['DeliveryTypeDesc'] != this.description) {
            const change = await this.$showAlert(
              'warning',
              'Edit Container',
              `Are you sure you want to save the data that you had made changes to Cont Delivery Type: "<b>${this.contDeliveryType}</b>"`,
              [
                { text: 'Confirm', textColor: 'white', color: 'red' },
                { text: 'Cancel', textColor: 'black', color: 'lightgray' },
              ],
            );
            if (change == 'Cancel') {
              return;
            }
          }
        }
        const trimmedDeliveryType = this.populateTextTrim(this.contDeliveryType);
        const dataToPost = {
          deliverytype: trimmedDeliveryType,
          deliverytypedesc: this.description,
          action: action,
          webview: this.webview && this.webview.API_Value ? this.webview.API_Value : '',
        };
        this.$fullscreenLoading(
          dataToPost['Action'] == 'D' ? 'Deleting Cont Delivery Type' : 'Saving Cont Delivery Type',
        );
        const result = await this.$apiCallV2('/ContDeliveryType/SaveContDeliveryType', dataToPost);
        this.$nextTick(async () => await this.getContDeliveryTypeList());
        this.$fullscreenLoading();
        if (result[0]['Results'] == 0) {
          // Save successful
          this.entrySuccess.push(
            `Successfully ${action == 'N' ? 'created' : 'edited'} Cont Delivery Type: ${this.contDeliveryType}`,
          );
          this.viewMode = true;
          this.viewModePK = true;
        } else {
          // Save error
          this.entryError.push(
            `There was an error ${action == 'N' ? 'creating' : 'editing'} Cont Delivery Type: ${result[0]['ErrMsg']}`,
          );
        }
      }
    },
    populateViewDetails: async function (contDeliveryTypeSelected) {
      this.$fullscreenLoading('Getting Details');
      const details = (
        await this.$apiCallV2('/Master/GetDetailsMaster', {
          masterfile: 'CONTDELIVERYTYPE',
          module: 'MASTER',
          recordid: contDeliveryTypeSelected,
        })
      )['ContDeliveryType'];
      this.contDeliveryType = this.populateTextTrim(details['DeliveryType']);
      this.description = this.populateTextTrim(details['DeliveryTypeDesc']);
      this.webview = this.populateObject(this.optionsForWebview, 'API_Value', details['WebView'] || '');
      this.updatedBy = `${details['UserID'].trim() ? details['UserID'].trim() : ''} ${details['DateUpdated'] ? new Date(details['DateUpdated']).formatString('dd/MM/yyyy HH:mm') : ''}`;
      this.createdBy = `${details['UserCreated'] || ''} ${details['TimeCreated'] ? new Date(details['TimeCreated']).formatString('dd/MM/yyyy HH:mm') : ''}`;
      this.$fullscreenLoading();
    },
    populateObject: function (data, key, compare) {
      // To populate object into dropdown or input query
      try {
        return data.find((d) => d[key].trim() == (compare ? compare.trim() : ''));
      } catch (error) {
        return null;
      }
    },
  },
  async mounted() {
    this.$bus.$on('pageSASControlAccess', (x) => {
      if (x.page == 'Cont Delivery Type') {
        x.data.forEach((k) => {
          //key in menu same as control value from api
          const selectedMenu = this.menu.find((m) => m['key'] == k['Control']);
          if (selectedMenu) {
            selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
          }
        });
      }
    });
    this.$fullscreenLoading('Getting Cont Delivery Type List');
    this.ContDeliveryTypeList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'contdeliverytype' });
    this.$fullscreenLoading();
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
@import '@/css/all.scss';

.cont-delivery-type-main {
  font-size: 12px;
  width: 100%;
  height: 100%;
  padding: 10px 45px;
  display: flex;
  .cont-delivery-type-table {
    width: 100%;
    margin-left: 5px;
    padding: 5px;
    background-color: white;
    border-radius: 5px;
    display: flex;
    overflow: hidden;
  }
  .gen-details-right {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .cont-delivery-type-size {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin: 10px;
  }
}
</style>
